<template slot="lang">
  <el-select
    v-model="language"
    v-loading.fullscreen.lock="loading"
    value=""
    class="lang-dropdown"
    placeholder="EN"
    @change="onLanguageChange()"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Lang',
  data() {
    return {
      language: '',
      loading: false,
    };
  },
  computed: {
    ...mapState({
      options: state => state.config.locales,
      stateLanguage: state => state.locale,
    }),
  },
  watch: {
    stateLanguage: {
      immediate: true,
      handler(language) {
        this.language = language;
      },
    },
  },
  methods: {
    onLanguageChange() {
      if (this.language !== this.stateLanguage) {
        this.loading = true;
        this.$store.dispatch('setLanguage', this.language)
          .then(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Lang.vue